module.exports = __webpack_public_path__ + "img/Competitionleft4.e0cd098d.png";